export class userType {
    public static MIDWIFE: string = "MIDWIFE";
    public static MUM: string = "MUM";
    public static BOTH: string = "BOTH";
}
export class BookingStatus {
    public static REQUESTED: string = "Requested";
    public static APPROVED: string = "Approved";
    public static DENIED: string = "Denied";
    public static COMPLETED: string = "Completed";
    public static NOT_COMPLETED = "Not Completed";
}

export class errorMessages{
  public static SOMETHING_WENT_WRONG:string = "Something went wrong !";
}

export class otpOption{
  public static EMAIL = "EMAIL";
  public static PHONE = "PHONE";
}

export class Direction{
  public static DECREMENT: string = "decrement";
  public static INCREMENT: string = "increment";
}

export class DateComponents {
  public static days = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15',
  '16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'];
  public static months = [
    {
      text: 'January',
      no: '01'
    },
    {
      text: 'February',
      no: '02'
    },
    {
      text: 'March',
      no: '03'
    },
    {
      text: 'April',
      no: '04'
    },
    {
      text: 'May',
      no: '05'
    },
    {
      text: 'June',
      no: '06'
    },
    {
      text: 'July',
      no: '07'
    },
    {
      text: 'August',
      no: '08'
    },
    {
      text: 'September',
      no: '09'
    },
    {
      text: 'October',
      no: '10'
    },
    {
      text: 'November',
      no: '11'
    },
    {
      text: 'December',
      no: '12'
    },
  ];
  public static days31 = ['01', '03', '05', '07', '08', '10', '12'];
  public static days30 = ['04', '06', '09', '11'];
}